export const OFD_TAXES: Array<{ label: string; value: number }> = [
  { label: 'НДС 20%', value: 1 },
  { label: 'НДС 10%', value: 2 },
  { label: 'НДС 20/120', value: 3 },
  { label: 'НДС 10/110', value: 4 },
  { label: 'НДС 0%', value: 5 },
  { label: 'НДС не облагается', value: 6 },
]

export const OFD_PAYMENT_METHODS: Array<{ label: string; value: number }> = [
  { label: 'Предоплата 100%', value: 1 },
  { label: 'Частичная предоплата', value: 2 },
  { label: 'Аванс', value: 3 },
  { label: 'Полный расчет', value: 4 },
  { label: 'Частичный расчет и кредит', value: 5 },
  { label: 'Передача в кредит', value: 6 },
  { label: 'Оплата кредита', value: 7 },
]

export const OFD_SUBJECT_TYPE: Array<{ label: string; value: number }> = [
  { label: 'Товар', value: 1 },
  { label: 'Подакцизный товар', value: 2 },
  { label: 'Работа', value: 3 },
  { label: 'Услуга', value: 4 },
  { label: 'Ставка азартной игры', value: 5 },
  { label: 'Выигрыш азартной игры', value: 6 },
  { label: 'Лотерейный билет', value: 7 },
  { label: 'Выигрыш лотереи', value: 8 },
  { label: 'Предоставление РИД', value: 9 },
  { label: 'Платеж', value: 10 },
  { label: 'Агентское вознаграждение', value: 11 },
  { label: 'Выплата', value: 12 },
  { label: 'Иной предмет расчета', value: 13 },
  { label: 'Имущественное право', value: 14 },
  { label: 'Внереализационный доход', value: 15 },
  { label: 'Иные платежи и взносы', value: 16 },
  { label: 'Торговый сбор', value: 17 },
  { label: 'Курортный сбор', value: 18 },
  { label: 'Залог', value: 19 },
  { label: 'Расход', value: 20 },
  { label: 'Взносы на ОПС ИП', value: 21 },
  { label: 'Взносы на ОПС', value: 22 },
  { label: 'Взносы на ОМС ИП', value: 23 },
  { label: 'Взносы на ОМС', value: 24 },
  { label: 'Взносы СоцСтрах', value: 25 },
  { label: 'Платеж казино', value: 26 },
  { label: 'Выдача денежных средств', value: 27 },
  { label: 'АТНМ (не имеющем кода маркировки)', value: 30 },
  { label: 'АТМ (имеющем кода маркировки)', value: 31 },
  { label: 'ТНМ', value: 32 },
  { label: 'ТМ', value: 33 },
]
